import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, normalizeClass as _normalizeClass, withDirectives as _withDirectives, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, vShow as _vShow, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-9c3e4e2c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { id: "contractLaborRequestMultiDayContent" }
const _hoisted_2 = {
  key: 0,
  id: "multiday-content-loading",
  class: "loadingDiv1",
  style: {"padding":"5px"}
}
const _hoisted_3 = { style: {"text-align":"center"} }
const _hoisted_4 = { class: "fa-2x" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createElementVNode("b", null, "Processing...")
], -1))
const _hoisted_6 = {
  id: "contractLaborRequestSingleDayView",
  class: "txtLeft"
}
const _hoisted_7 = { class: "row rowMultiDay mb-3" }
const _hoisted_8 = { class: "col-3" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "text-uppercase default-font-size" }, "facility", -1))
const _hoisted_10 = ["value"]
const _hoisted_11 = { class: "col-3" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "text-uppercase default-font-size" }, "department", -1))
const _hoisted_13 = ["value"]
const _hoisted_14 = { class: "col-2" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "text-uppercase default-font-size" }, "date", -1))
const _hoisted_16 = { class: "col-2" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "text-uppercase default-font-size" }, "shift", -1))
const _hoisted_18 = ["value"]
const _hoisted_19 = { class: "col-2" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "text-uppercase default-font-size" }, "skill", -1))
const _hoisted_21 = ["value"]
const _hoisted_22 = { class: "row rowMultiDay mb-3" }
const _hoisted_23 = { class: "col-3" }
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "text-uppercase default-font-size" }, "specialization", -1))
const _hoisted_25 = ["value"]
const _hoisted_26 = { class: "col-3" }
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "text-uppercase default-font-size" }, "number of resources", -1))
const _hoisted_28 = {
  key: 0,
  class: "requiredControl material-icons",
  "aria-hidden": "true"
}
const _hoisted_29 = { class: "col-4" }
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "text-uppercase default-font-size" }, "notes", -1))
const _hoisted_31 = {
  class: "col-2 search-wrapper",
  style: {"padding-top":"20px"}
}
const _hoisted_32 = { class: "row rowMultiDay" }
const _hoisted_33 = { class: "col-12" }
const _hoisted_34 = { class: "assignment-list ms-1 me-1" }
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "Request ", -1))
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "Activity Log ", -1))
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "Manage Contract ", -1))
const _hoisted_38 = {
  key: 0,
  id: "multiDayRequestConfirmationTabContent",
  class: "panelTabData scrollBar",
  role: "tabpanel"
}
const _hoisted_39 = { class: "row multiDayNoRequestHeading" }
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col d-flex justify-content-center mt-5" }, [
  /*#__PURE__*/_createElementVNode("h4", null, "No requests submitted. Please request one above.")
], -1))
const _hoisted_41 = [
  _hoisted_40
]
const _hoisted_42 = { class: "row multiDayRequestConfirmationSection" }
const _hoisted_43 = {
  key: 1,
  id: "period-message-text"
}
const _hoisted_44 = { class: "multiday-request-controls-form mt-2" }
const _hoisted_45 = /*#__PURE__*/_createStaticVNode("<div class=\"row\" data-v-9c3e4e2c><div class=\"form-group col-3\" data-v-9c3e4e2c>FACILITY</div><div class=\"form-group col-3\" data-v-9c3e4e2c>DEPT.</div><div class=\"form-group col-2\" data-v-9c3e4e2c>DATE</div><div class=\"form-group col-2\" data-v-9c3e4e2c>SHIFT</div><div class=\"form-group col-2\" data-v-9c3e4e2c>SKILL</div></div>", 1)
const _hoisted_46 = {
  id: "view",
  "data-role": "list-view",
  "data-bind": "source: contractRequestControls"
}
const _hoisted_47 = { class: "row" }
const _hoisted_48 = { class: "form-group col-3" }
const _hoisted_49 = ["onUpdate:modelValue", "onChange"]
const _hoisted_50 = ["value"]
const _hoisted_51 = { class: "form-group col-3" }
const _hoisted_52 = ["onUpdate:modelValue", "onChange"]
const _hoisted_53 = ["value"]
const _hoisted_54 = { class: "form-group col-2" }
const _hoisted_55 = {
  class: "form-group col-2",
  "data-bind": "attr:{data-id:uid}"
}
const _hoisted_56 = ["onUpdate:modelValue"]
const _hoisted_57 = ["value"]
const _hoisted_58 = {
  class: "form-group col-2",
  "data-bind": "attr:{data-id:uid}"
}
const _hoisted_59 = ["onUpdate:modelValue"]
const _hoisted_60 = ["value"]
const _hoisted_61 = { class: "row mb-3" }
const _hoisted_62 = {
  class: "form-group col-3",
  "data-bind": "attr:{data-id:uid}"
}
const _hoisted_63 = ["onUpdate:modelValue"]
const _hoisted_64 = ["value"]
const _hoisted_65 = { class: "form-group col-2" }
const _hoisted_66 = { class: "form-group col-5" }
const _hoisted_67 = { class: "form-group col-2" }
const _hoisted_68 = ["onClick"]
const _hoisted_69 = ["onClick"]
const _hoisted_70 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "row" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "col txtLeft" }, "   ")
], -1))
const _hoisted_71 = { class: "row" }
const _hoisted_72 = { class: "col d-flex justify-content-center mt-5" }
const _hoisted_73 = {
  key: 1,
  id: "multiDayMyRecentActivityTabContent",
  class: "panelTabData scrollBar",
  role: "tabpanel"
}
const _hoisted_74 = {
  key: 1,
  id: "period-message-text"
}
const _hoisted_75 = {
  key: 2,
  id: "multiDayManageContractTabContent",
  class: "panelTabData scrollBar",
  role: "tabpanel"
}
const _hoisted_76 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_77 = { class: "col" }
const _hoisted_78 = ["href"]
const _hoisted_79 = { key: 0 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_neu_icon = _resolveComponent("neu-icon")!
  const _component_Datepicker = _resolveComponent("Datepicker")!
  const _component_neu_input = _resolveComponent("neu-input")!
  const _component_neu_button = _resolveComponent("neu-button")!
  const _component_neu_tab = _resolveComponent("neu-tab")!
  const _component_neu_tablist = _resolveComponent("neu-tablist")!
  const _component_neu_table_heading = _resolveComponent("neu-table-heading")!
  const _component_neu_table_row = _resolveComponent("neu-table-row")!
  const _component_neu_label = _resolveComponent("neu-label")!
  const _component_neu_table_body = _resolveComponent("neu-table-body")!
  const _component_neu_table = _resolveComponent("neu-table")!
  const _component_neu_card = _resolveComponent("neu-card")!
  const _component_neu_paginator = _resolveComponent("neu-paginator")!
  const _component_neu_col = _resolveComponent("neu-col")!
  const _component_neu_table_row_count = _resolveComponent("neu-table-row-count")!
  const _component_neu_row = _resolveComponent("neu-row")!
  const _component_neu_container = _resolveComponent("neu-container")!
  const _component_ToasterPopup = _resolveComponent("ToasterPopup")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      (_ctx.isShowContractLaborLoader)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, [
                _createVNode(_component_font_awesome_icon, {
                  spin: true,
                  icon: ['fas', 'circle-notch'],
                  size: "lg"
                })
              ]),
              _hoisted_5
            ])
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("div", _hoisted_8, [
            _hoisted_9,
            _withDirectives(_createElementVNode("select", {
              class: _normalizeClass(["neu-select", [_ctx.isFacilityError ? 'hasError': '']]),
              name: "facility",
              id: "multiDaySearchFacility",
              "data-role": "dropdownlist",
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.selectedFacility) = $event)),
              onChange: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.onFacilityChange && _ctx.onFacilityChange(...args)))
            }, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.facilities, (fac) => {
                return (_openBlock(), _createElementBlock("option", {
                  value: fac.Value,
                  key: fac.Value
                }, _toDisplayString(fac.Text), 9, _hoisted_10))
              }), 128))
            ], 34), [
              [_vModelSelect, _ctx.selectedFacility]
            ]),
            _createVNode(_component_neu_icon, { class: "material-icons neu-input__select-icon z-max" }, {
              default: _withCtx(() => [
                _createTextVNode("arrow_drop_down")
              ]),
              _: 1
            }),
            (_ctx.isFacilityError)
              ? (_openBlock(), _createBlock(_component_neu_icon, {
                  key: 0,
                  class: "requiredControl material-icons",
                  "aria-hidden": "true"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("error")
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_11, [
            _hoisted_12,
            _withDirectives(_createElementVNode("select", {
              class: _normalizeClass(["neu-select", [_ctx.isDepartmentError ? 'hasError': '']]),
              name: "department",
              id: "multiDaySearchDepartment",
              "data-role": "dropdownlist",
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.selectedDepartment) = $event)),
              onChange: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.onDepartmentChange && _ctx.onDepartmentChange(...args)))
            }, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.departments, (dept) => {
                return (_openBlock(), _createElementBlock("option", {
                  value: dept.Value,
                  key: dept.Value
                }, _toDisplayString(dept.Text), 9, _hoisted_13))
              }), 128))
            ], 34), [
              [_vModelSelect, _ctx.selectedDepartment]
            ]),
            _createVNode(_component_neu_icon, { class: "material-icons neu-input__select-icon z-max" }, {
              default: _withCtx(() => [
                _createTextVNode("arrow_drop_down")
              ]),
              _: 1
            }),
            (_ctx.isDepartmentError)
              ? (_openBlock(), _createBlock(_component_neu_icon, {
                  key: 0,
                  class: "requiredControl material-icons",
                  "aria-hidden": "true"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("error")
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_14, [
            _hoisted_15,
            _createVNode(_component_Datepicker, {
              modelValue: _ctx.requestDate,
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.requestDate) = $event)),
              weekStart: "0",
              inputClassName: "dp-custom-input",
              class: _normalizeClass(["form-control requestDate", [_ctx.isRequestDateError ? 'hasError': '']]),
              style: {"width":"100%"},
              enableTimePicker: false,
              autoApply: ""
            }, null, 8, ["modelValue", "class"]),
            (_ctx.isRequestDateError)
              ? (_openBlock(), _createBlock(_component_neu_icon, {
                  key: 0,
                  class: "requiredControl material-icons",
                  "aria-hidden": "true"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("error")
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_16, [
            _hoisted_17,
            _withDirectives(_createElementVNode("select", {
              class: _normalizeClass(["neu-select", [_ctx.isShiftError ? 'hasError': '']]),
              name: "shift",
              id: "multiDaySearchShift",
              "data-role": "dropdownlist",
              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.selectedShift) = $event))
            }, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.shifts, (shft) => {
                return (_openBlock(), _createElementBlock("option", {
                  value: shft.deptShiftId,
                  key: shft.deptShiftId
                }, _toDisplayString(shft.deptShiftDescription), 9, _hoisted_18))
              }), 128))
            ], 2), [
              [_vModelSelect, _ctx.selectedShift]
            ]),
            _createVNode(_component_neu_icon, { class: "material-icons neu-input__select-icon z-max" }, {
              default: _withCtx(() => [
                _createTextVNode("arrow_drop_down")
              ]),
              _: 1
            }),
            (_ctx.isShiftError)
              ? (_openBlock(), _createBlock(_component_neu_icon, {
                  key: 0,
                  class: "requiredControl material-icons",
                  "aria-hidden": "true"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("error")
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_19, [
            _hoisted_20,
            _withDirectives(_createElementVNode("select", {
              class: _normalizeClass(["neu-select", [_ctx.isSkillError ? 'hasError': '']]),
              name: "skill",
              id: "multiDaySearchSkill",
              "data-role": "dropdownlist",
              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.selectedSkill) = $event))
            }, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.skills, (skl) => {
                return (_openBlock(), _createElementBlock("option", {
                  value: skl.skillLevelId,
                  key: skl.skillLevelId
                }, _toDisplayString(skl.description), 9, _hoisted_21))
              }), 128))
            ], 2), [
              [_vModelSelect, _ctx.selectedSkill]
            ]),
            _createVNode(_component_neu_icon, { class: "material-icons neu-input__select-icon z-max" }, {
              default: _withCtx(() => [
                _createTextVNode("arrow_drop_down")
              ]),
              _: 1
            }),
            (_ctx.isSkillError)
              ? (_openBlock(), _createBlock(_component_neu_icon, {
                  key: 0,
                  class: "requiredControl material-icons",
                  "aria-hidden": "true"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("error")
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true)
          ])
        ]),
        _createElementVNode("div", _hoisted_22, [
          _createElementVNode("div", _hoisted_23, [
            _hoisted_24,
            _withDirectives(_createElementVNode("select", {
              class: _normalizeClass(["neu-select", [_ctx.isSpecializationError ? 'hasError': '']]),
              name: "skillSpecialization",
              id: "multiDaySearchSpecialization",
              "data-role": "dropdownlist",
              "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.selectedSkillSpecialization) = $event))
            }, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.skillSpecializations, (fac) => {
                return (_openBlock(), _createElementBlock("option", {
                  value: fac.wfFoldergroupID,
                  key: fac.wfFoldergroupID
                }, _toDisplayString(fac.wfFolderGroupName), 9, _hoisted_25))
              }), 128))
            ], 2), [
              [_vModelSelect, _ctx.selectedSkillSpecialization]
            ]),
            _createVNode(_component_neu_icon, { class: "material-icons neu-input__select-icon z-max" }, {
              default: _withCtx(() => [
                _createTextVNode("arrow_drop_down")
              ]),
              _: 1
            }),
            (_ctx.isSpecializationError)
              ? (_openBlock(), _createBlock(_component_neu_icon, {
                  key: 0,
                  class: "requiredControl material-icons",
                  "aria-hidden": "true"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("error")
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_26, [
            _hoisted_27,
            _createVNode(_component_neu_input, {
              id: "resource-count",
              modelValue: _ctx.resourceCount,
              "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.resourceCount) = $event)),
              class: _normalizeClass([_ctx.isResourcesCountError ? 'hasError': ''])
            }, null, 8, ["modelValue", "class"]),
            (_ctx.isResourcesCountError)
              ? (_openBlock(), _createElementBlock("span", _hoisted_28, "error"))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_29, [
            _hoisted_30,
            _createVNode(_component_neu_input, {
              id: "notes",
              modelValue: _ctx.notes,
              "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.notes) = $event))
            }, null, 8, ["modelValue"])
          ]),
          _createElementVNode("div", _hoisted_31, [
            _createVNode(_component_neu_button, {
              type: "button",
              fill: "raised",
              id: "WFRequestStatusSearch",
              disabled: _ctx.isDisableCreateRequest,
              class: "float-end me-1",
              onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.isDisableCreateRequest ? null : _ctx.onAddRequestControls()))
            }, {
              default: _withCtx(() => [
                _createTextVNode(" ADD REQUEST ")
              ]),
              _: 1
            }, 8, ["disabled"])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_32, [
        _createElementVNode("div", _hoisted_33, [
          _createElementVNode("div", _hoisted_34, [
            _createVNode(_component_neu_tablist, {
              value: _ctx.selectedTab,
              class: "mx-4 tabList txtLeft"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_neu_tab, {
                  white: "",
                  tab: "RequestConfirmationTab",
                  onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.setSelectedTab('RequestConfirmationTab')))
                }, {
                  default: _withCtx(() => [
                    _hoisted_35
                  ]),
                  _: 1
                }),
                _createVNode(_component_neu_tab, {
                  white: "",
                  tab: "ActivityLogTab",
                  onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.setSelectedTab('ActivityLogTab')))
                }, {
                  default: _withCtx(() => [
                    _hoisted_36
                  ]),
                  _: 1
                }),
                _createVNode(_component_neu_tab, {
                  white: "",
                  tab: "ManageContractTab",
                  onClick: _cache[13] || (_cache[13] = ($event: any) => (_ctx.setSelectedTab('ManageContractTab')))
                }, {
                  default: _withCtx(() => [
                    _hoisted_37
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["value"]),
            (_ctx.isRequestConfirmationVisible)
              ? (_openBlock(), _createElementBlock("div", _hoisted_38, [
                  _withDirectives(_createElementVNode("div", _hoisted_39, _hoisted_41, 512), [
                    [_vShow, _ctx.showNoRequestHeading]
                  ]),
                  _withDirectives(_createElementVNode("div", _hoisted_42, [
                    _createVNode(_component_neu_card, {
                      color: "plain-0",
                      class: "p-0 m-0"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_neu_table, null, {
                          default: _withCtx(() => [
                            _createVNode(_component_neu_table_row, {
                              columns: _ctx.createdRequestsColumnHeaders,
                              header: ""
                            }, {
                              default: _withCtx(() => [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(Object.keys(_ctx.createdRequestsColumnHeaders), (column) => {
                                  return (_openBlock(), _createBlock(_component_neu_table_heading, {
                                    key: column,
                                    icon: _ctx.createdRequestsColumnIcons[column],
                                    slot: column,
                                    style: {"padding-top":"25px !important"}
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(column), 1)
                                    ]),
                                    _: 2
                                  }, 1032, ["icon", "slot"]))
                                }), 128))
                              ]),
                              _: 1
                            }, 8, ["columns"]),
                            _createVNode(_component_neu_table_body, { align: "left" }, {
                              default: _withCtx(() => [
                                (_ctx.createdContractLaborShiftRequest != null && _ctx.createdContractLaborShiftRequest.length > 0)
                                  ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.createdContractLaborShiftRequest, (createdContractLbr) => {
                                      return (_openBlock(), _createBlock(_component_neu_table_row, {
                                        columns: _ctx.createdRequestsColumnHeaders,
                                        key: createdContractLbr,
                                        slot: _ctx.column
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_neu_label, {
                                            slot: "Facility",
                                            title: createdContractLbr.requests[0].facilityName
                                          }, {
                                            default: _withCtx(() => [
                                              _createTextVNode(_toDisplayString(createdContractLbr.requests[0].facilityName), 1)
                                            ]),
                                            _: 2
                                          }, 1032, ["title"]),
                                          _createVNode(_component_neu_label, {
                                            slot: "Dept",
                                            title: createdContractLbr.requests[0].fsDeptDescription
                                          }, {
                                            default: _withCtx(() => [
                                              _createTextVNode(_toDisplayString(createdContractLbr.requests[0].fsDeptDescription), 1)
                                            ]),
                                            _: 2
                                          }, 1032, ["title"]),
                                          _createVNode(_component_neu_label, { slot: "Date" }, {
                                            default: _withCtx(() => [
                                              _createTextVNode(_toDisplayString(_ctx.setCreatedContractLbrGridDate(createdContractLbr.requests[0].date)), 1)
                                            ]),
                                            _: 2
                                          }, 1024),
                                          _createVNode(_component_neu_label, {
                                            slot: "Shift",
                                            title: _ctx.setCreatedContractLbrGridShiftDescription(createdContractLbr.requests[0])
                                          }, {
                                            default: _withCtx(() => [
                                              _createTextVNode(_toDisplayString(_ctx.setCreatedContractLbrGridShiftDescription(createdContractLbr.requests[0])), 1)
                                            ]),
                                            _: 2
                                          }, 1032, ["title"]),
                                          _createVNode(_component_neu_label, {
                                            slot: "Skill",
                                            title: createdContractLbr.requests[0].fsSkillLevelDescription
                                          }, {
                                            default: _withCtx(() => [
                                              _createTextVNode(_toDisplayString(createdContractLbr.requests[0].fsSkillLevelDescription), 1)
                                            ]),
                                            _: 2
                                          }, 1032, ["title"]),
                                          _createVNode(_component_neu_label, {
                                            slot: "Specialization",
                                            title: createdContractLbr.requests[0].wfFolderGroupName
                                          }, {
                                            default: _withCtx(() => [
                                              _createTextVNode(_toDisplayString(createdContractLbr.requests[0].wfFolderGroupName), 1)
                                            ]),
                                            _: 2
                                          }, 1032, ["title"]),
                                          _createVNode(_component_neu_label, {
                                            slot: "Resource",
                                            title: createdContractLbr.requests.length
                                          }, {
                                            default: _withCtx(() => [
                                              _createTextVNode(_toDisplayString(createdContractLbr.requests.length), 1)
                                            ]),
                                            _: 2
                                          }, 1032, ["title"]),
                                          _createVNode(_component_neu_label, {
                                            slot: "Notes",
                                            title: createdContractLbr.requests[0].notes
                                          }, {
                                            default: _withCtx(() => [
                                              _createTextVNode(_toDisplayString(createdContractLbr.requests[0].notes), 1)
                                            ]),
                                            _: 2
                                          }, 1032, ["title"]),
                                          _createVNode(_component_neu_label, { slot: "Action" }, {
                                            default: _withCtx(() => [
                                              _createVNode(_component_neu_button, {
                                                type: "button",
                                                fill: "raised",
                                                id: "multiDayCancelRequestbutton",
                                                onClick: ($event: any) => (_ctx.cancelRequests(createdContractLbr.requestId))
                                              }, {
                                                default: _withCtx(() => [
                                                  _createTextVNode(" CANCEL ")
                                                ]),
                                                _: 2
                                              }, 1032, ["onClick"])
                                            ]),
                                            _: 2
                                          }, 1024)
                                        ]),
                                        _: 2
                                      }, 1032, ["columns", "slot"]))
                                    }), 128))
                                  : (_openBlock(), _createElementBlock("p", _hoisted_43, "No data available on current page."))
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ], 512), [
                    [_vShow, _ctx.showRequestConfirmation]
                  ]),
                  _withDirectives(_createElementVNode("div", _hoisted_44, [
                    _hoisted_45,
                    _createElementVNode("div", _hoisted_46, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.contractRequestControls, (controls) => {
                        return (_openBlock(), _createElementBlock("div", {
                          class: "multiday-request-controls",
                          key: controls.Id
                        }, [
                          _createElementVNode("div", _hoisted_47, [
                            _createElementVNode("div", _hoisted_48, [
                              _withDirectives(_createElementVNode("select", {
                                class: _normalizeClass(["neu-select", [controls.isFacilityError ? 'hasError': '']]),
                                name: "facility",
                                id: "multiDayControls-facility",
                                "data-role": "dropdownlist",
                                "onUpdate:modelValue": ($event: any) => ((controls.SelectedFacility) = $event),
                                onChange: ($event: any) => (_ctx.onControlsFacilityChange(controls.Id))
                              }, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(controls.Facilities, (fac) => {
                                  return (_openBlock(), _createElementBlock("option", {
                                    value: fac.Value,
                                    key: fac.Value
                                  }, _toDisplayString(fac.Text), 9, _hoisted_50))
                                }), 128))
                              ], 42, _hoisted_49), [
                                [_vModelSelect, controls.SelectedFacility]
                              ]),
                              _createVNode(_component_neu_icon, {
                                class: "material-icons neu-input__select-icon z-max",
                                style: {"top":"0.4rem !important"}
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode("arrow_drop_down")
                                ]),
                                _: 1
                              }),
                              (controls.isFacilityError)
                                ? (_openBlock(), _createBlock(_component_neu_icon, {
                                    key: 0,
                                    class: "requiredControl material-icons",
                                    style: {"top":"0.5rem !important"},
                                    "aria-hidden": "true"
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode("error")
                                    ]),
                                    _: 1
                                  }))
                                : _createCommentVNode("", true)
                            ]),
                            _createElementVNode("div", _hoisted_51, [
                              _withDirectives(_createElementVNode("select", {
                                class: _normalizeClass(["neu-select", [controls.isDepartmentError ? 'hasError': '']]),
                                name: "department",
                                id: "multiDayControls-department",
                                "data-role": "dropdownlist",
                                "onUpdate:modelValue": ($event: any) => ((controls.SelectedDepartment) = $event),
                                onChange: ($event: any) => (_ctx.onControlsDepartmentChange(controls.Id))
                              }, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(controls.Departments, (dept) => {
                                  return (_openBlock(), _createElementBlock("option", {
                                    value: dept.Value,
                                    key: dept.Value
                                  }, _toDisplayString(dept.Text), 9, _hoisted_53))
                                }), 128))
                              ], 42, _hoisted_52), [
                                [_vModelSelect, controls.SelectedDepartment]
                              ]),
                              _createVNode(_component_neu_icon, {
                                class: "material-icons neu-input__select-icon z-max",
                                style: {"top":"0.4rem !important"}
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode("arrow_drop_down")
                                ]),
                                _: 1
                              }),
                              (controls.isDepartmentError)
                                ? (_openBlock(), _createBlock(_component_neu_icon, {
                                    key: 0,
                                    class: "requiredControl material-icons",
                                    style: {"top":"0.5rem !important"},
                                    "aria-hidden": "true"
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode("error")
                                    ]),
                                    _: 1
                                  }))
                                : _createCommentVNode("", true)
                            ]),
                            _createElementVNode("div", _hoisted_54, [
                              _createVNode(_component_Datepicker, {
                                modelValue: controls.RequestDate,
                                "onUpdate:modelValue": [($event: any) => ((controls.RequestDate) = $event), ($event: any) => (_ctx.onControlsRequestDateChange(_ctx.modelData, controls.Id))],
                                weekStart: "0",
                                inputClassName: "dp-custom-input",
                                class: _normalizeClass(["form-control multiDayControls-requestDate", [controls.isRequestDateError ? 'hasError': '']]),
                                style: {"width":"100%"},
                                enableTimePicker: false,
                                autoApply: ""
                              }, null, 8, ["modelValue", "onUpdate:modelValue", "class"]),
                              (controls.isRequestDateError)
                                ? (_openBlock(), _createBlock(_component_neu_icon, {
                                    key: 0,
                                    class: "requiredControl material-icons",
                                    "aria-hidden": "true",
                                    style: {"top":"0.5rem !important"}
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode("error")
                                    ]),
                                    _: 1
                                  }))
                                : _createCommentVNode("", true)
                            ]),
                            _createElementVNode("div", _hoisted_55, [
                              _withDirectives(_createElementVNode("select", {
                                class: _normalizeClass(["neu-select", [controls.isShiftError ? 'hasError': '']]),
                                name: "shift",
                                id: "multiDayControls-departmentShifts",
                                "data-role": "dropdownlist",
                                "onUpdate:modelValue": ($event: any) => ((controls.SelectedShift) = $event)
                              }, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(controls.Shifts, (shift) => {
                                  return (_openBlock(), _createElementBlock("option", {
                                    value: shift.deptShiftId,
                                    key: shift.deptShiftId
                                  }, _toDisplayString(shift.deptShiftDescription), 9, _hoisted_57))
                                }), 128))
                              ], 10, _hoisted_56), [
                                [_vModelSelect, controls.SelectedShift]
                              ]),
                              _createVNode(_component_neu_icon, {
                                class: "material-icons neu-input__select-icon z-max",
                                style: {"top":"0.4rem !important"}
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode("arrow_drop_down")
                                ]),
                                _: 1
                              }),
                              (controls.isShiftError)
                                ? (_openBlock(), _createBlock(_component_neu_icon, {
                                    key: 0,
                                    class: "requiredControl material-icons",
                                    "aria-hidden": "true",
                                    style: {"top":"0.5rem !important"}
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode("error")
                                    ]),
                                    _: 1
                                  }))
                                : _createCommentVNode("", true)
                            ]),
                            _createElementVNode("div", _hoisted_58, [
                              _withDirectives(_createElementVNode("select", {
                                class: _normalizeClass(["neu-select", [controls.isSkillError ? 'hasError': '']]),
                                name: "skill",
                                id: "multiDayControls-skills",
                                "data-role": "dropdownlist",
                                "onUpdate:modelValue": ($event: any) => ((controls.SelectedSkill) = $event)
                              }, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(controls.Skills, (skill) => {
                                  return (_openBlock(), _createElementBlock("option", {
                                    value: skill.skillLevelId,
                                    key: skill.skillLevelId
                                  }, _toDisplayString(skill.description), 9, _hoisted_60))
                                }), 128))
                              ], 10, _hoisted_59), [
                                [_vModelSelect, controls.SelectedSkill]
                              ]),
                              _createVNode(_component_neu_icon, {
                                class: "material-icons neu-input__select-icon z-max",
                                style: {"top":"0.4rem !important"}
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode("arrow_drop_down")
                                ]),
                                _: 1
                              }),
                              (controls.isSkillError)
                                ? (_openBlock(), _createBlock(_component_neu_icon, {
                                    key: 0,
                                    class: "requiredControl material-icons",
                                    "aria-hidden": "true",
                                    style: {"top":"0.5rem !important"}
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode("error")
                                    ]),
                                    _: 1
                                  }))
                                : _createCommentVNode("", true)
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_61, [
                            _createElementVNode("div", _hoisted_62, [
                              _withDirectives(_createElementVNode("select", {
                                class: _normalizeClass(["neu-select", [controls.isSpecializationError ? 'hasError': '']]),
                                name: "skillSpecialization",
                                id: "multiDayControls-skillSpecialization",
                                "data-role": "dropdownlist",
                                "onUpdate:modelValue": ($event: any) => ((controls.SelectedSkillSpecialization) = $event)
                              }, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(controls.SkillSpecializations, (fac) => {
                                  return (_openBlock(), _createElementBlock("option", {
                                    value: fac.wfFoldergroupID,
                                    key: fac.wfFoldergroupID
                                  }, _toDisplayString(fac.wfFolderGroupName), 9, _hoisted_64))
                                }), 128))
                              ], 10, _hoisted_63), [
                                [_vModelSelect, controls.SelectedSkillSpecialization]
                              ]),
                              _createVNode(_component_neu_icon, {
                                class: "material-icons neu-input__select-icon z-max",
                                style: {"top":"0.4rem !important"}
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode("arrow_drop_down")
                                ]),
                                _: 1
                              }),
                              (controls.isSpecializationError)
                                ? (_openBlock(), _createBlock(_component_neu_icon, {
                                    key: 0,
                                    class: "requiredControl material-icons",
                                    style: {"top":"0.5rem !important"},
                                    "aria-hidden": "true"
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode("error")
                                    ]),
                                    _: 1
                                  }))
                                : _createCommentVNode("", true)
                            ]),
                            _createElementVNode("div", _hoisted_65, [
                              _createVNode(_component_neu_input, {
                                id: "multiDayControls-ResourceCount",
                                modelValue: controls.ResourceCount,
                                "onUpdate:modelValue": ($event: any) => ((controls.ResourceCount) = $event),
                                class: _normalizeClass([controls.isResourcesCountError ? 'hasError': ''])
                              }, null, 8, ["modelValue", "onUpdate:modelValue", "class"]),
                              (controls.isResourcesCountError)
                                ? (_openBlock(), _createBlock(_component_neu_icon, {
                                    key: 0,
                                    class: "requiredControl material-icons",
                                    style: {"left":"8.2rem !important","top":"0.5rem !important"},
                                    "aria-hidden": "true"
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode("error")
                                    ]),
                                    _: 1
                                  }))
                                : _createCommentVNode("", true)
                            ]),
                            _createElementVNode("div", _hoisted_66, [
                              _createVNode(_component_neu_input, {
                                id: "multiDayControls-notes",
                                modelValue: controls.note,
                                "onUpdate:modelValue": ($event: any) => ((controls.note) = $event)
                              }, null, 8, ["modelValue", "onUpdate:modelValue"])
                            ]),
                            _createElementVNode("div", _hoisted_67, [
                              _createElementVNode("button", {
                                type: "button",
                                class: "btn btn-link multiday-remove-request-btn float-right tmptRemoveBtn",
                                style: {"padding-top":"10px"},
                                onClick: ($event: any) => (_ctx.onRemoveRequestlnk(controls.Id))
                              }, [
                                _createVNode(_component_font_awesome_icon, {
                                  icon: ['far', 'trash-alt'],
                                  size: "sm",
                                  class: "mr-1"
                                }),
                                _createTextVNode(" Remove ")
                              ], 8, _hoisted_68),
                              _createElementVNode("button", {
                                type: "button",
                                class: "btn btn-link multiday-copy-request-btn float-right tmptCopyBtn",
                                style: {"padding-top":"10px"},
                                onClick: ($event: any) => (_ctx.onCopyRequestlnk(controls.Id))
                              }, [
                                _createVNode(_component_font_awesome_icon, {
                                  icon: ['far', 'copy'],
                                  size: "sm",
                                  class: "mr-1"
                                }),
                                _createTextVNode(" Copy ")
                              ], 8, _hoisted_69)
                            ])
                          ])
                        ]))
                      }), 128))
                    ]),
                    _hoisted_70,
                    _createElementVNode("div", _hoisted_71, [
                      _createElementVNode("div", _hoisted_72, [
                        _createElementVNode("button", {
                          type: "button",
                          class: "btn btn-primary text-uppercase multi-day-submit-request-btn",
                          onClick: _cache[14] || (_cache[14] = 
//@ts-ignore
(...args) => (_ctx.createContractLaborRequest && _ctx.createContractLaborRequest(...args)))
                        }, "Submit Request")
                      ])
                    ])
                  ], 512), [
                    [_vShow, _ctx.showRequestForm]
                  ])
                ]))
              : _createCommentVNode("", true),
            (_ctx.isActivityLogVisible)
              ? (_openBlock(), _createElementBlock("div", _hoisted_73, [
                  _createVNode(_component_neu_card, {
                    color: "plain-0",
                    class: "p-0 m-0"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_neu_table, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_neu_table_row, {
                            columns: _ctx.columnHeaders,
                            header: ""
                          }, {
                            default: _withCtx(() => [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(Object.keys(_ctx.columnHeaders), (column) => {
                                return (_openBlock(), _createBlock(_component_neu_table_heading, {
                                  key: column,
                                  icon: _ctx.columnIcons[column],
                                  slot: column,
                                  style: {"padding-top":"25px !important"}
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(column), 1)
                                  ]),
                                  _: 2
                                }, 1032, ["icon", "slot"]))
                              }), 128))
                            ]),
                            _: 1
                          }, 8, ["columns"]),
                          _createVNode(_component_neu_table_body, { align: "left" }, {
                            default: _withCtx(() => [
                              (_ctx.activityLogGridData != null && _ctx.activityLogGridData.length > 0)
                                ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.activityLogGridData, (activityLog) => {
                                    return (_openBlock(), _createBlock(_component_neu_table_row, {
                                      columns: _ctx.columnHeaders,
                                      key: activityLog,
                                      slot: _ctx.column
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_neu_label, {
                                          slot: "Requested At",
                                          title: activityLog.createdDate
                                        }, {
                                          default: _withCtx(() => [
                                            _createTextVNode(_toDisplayString(activityLog.createdDate), 1)
                                          ]),
                                          _: 2
                                        }, 1032, ["title"]),
                                        _createVNode(_component_neu_label, {
                                          slot: "Action",
                                          title: activityLog.transactionName
                                        }, {
                                          default: _withCtx(() => [
                                            _createTextVNode(_toDisplayString(activityLog.transactionName), 1)
                                          ]),
                                          _: 2
                                        }, 1032, ["title"]),
                                        _createVNode(_component_neu_label, {
                                          slot: "Facility",
                                          title: activityLog.facilityName
                                        }, {
                                          default: _withCtx(() => [
                                            _createTextVNode(_toDisplayString(activityLog.facilityName), 1)
                                          ]),
                                          _: 2
                                        }, 1032, ["title"]),
                                        _createVNode(_component_neu_label, {
                                          slot: "Department",
                                          title: activityLog.departmentName
                                        }, {
                                          default: _withCtx(() => [
                                            _createTextVNode(_toDisplayString(activityLog.departmentName), 1)
                                          ]),
                                          _: 2
                                        }, 1032, ["title"]),
                                        _createVNode(_component_neu_label, {
                                          slot: "Skill",
                                          title: activityLog.skill
                                        }, {
                                          default: _withCtx(() => [
                                            _createTextVNode(_toDisplayString(activityLog.skill), 1)
                                          ]),
                                          _: 2
                                        }, 1032, ["title"]),
                                        _createVNode(_component_neu_label, {
                                          slot: "Requested For",
                                          title: activityLog.requestedForDate
                                        }, {
                                          default: _withCtx(() => [
                                            _createTextVNode(_toDisplayString(activityLog.requestedForDate), 1)
                                          ]),
                                          _: 2
                                        }, 1032, ["title"]),
                                        _createVNode(_component_neu_label, {
                                          slot: "User",
                                          title: activityLog.userInfo
                                        }, {
                                          default: _withCtx(() => [
                                            _createTextVNode(_toDisplayString(activityLog.userInfo), 1)
                                          ]),
                                          _: 2
                                        }, 1032, ["title"]),
                                        _createVNode(_component_neu_label, {
                                          slot: "Details",
                                          title: activityLog.details
                                        }, {
                                          default: _withCtx(() => [
                                            _createTextVNode(_toDisplayString(activityLog.details), 1)
                                          ]),
                                          _: 2
                                        }, 1032, ["title"])
                                      ]),
                                      _: 2
                                    }, 1032, ["columns", "slot"]))
                                  }), 128))
                                : (_openBlock(), _createElementBlock("p", _hoisted_74, "No data available on current page."))
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  (_ctx.activityLogGridData != null && _ctx.activityLogGridData.length > 0)
                    ? (_openBlock(), _createBlock(_component_neu_container, {
                        key: 0,
                        fluid: ""
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_neu_row, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_neu_col, {
                                md: "6",
                                cols: "12",
                                class: "neu-text-center neu-text-md-left"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_neu_paginator, {
                                    class: "justify-content-start",
                                    onVNeuChange: _cache[15] || (_cache[15] = (ev) => this.pageNum = ev.detail.pageNumber),
                                    total: _ctx.activityLogGridData != null && _ctx.activityLogGridData.length,
                                    rowsPerPage: _ctx.rowsPerPage
                                  }, null, 8, ["total", "rowsPerPage"])
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_neu_col, {
                                md: "6",
                                cols: "12",
                                class: "neu-text-center neu-text-md-right"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_neu_table_row_count, {
                                    class: "mt-3",
                                    section: "number",
                                    total: _ctx.activityLogGridData != null && _ctx.activityLogGridData.length,
                                    "page-number": _ctx.pageNum,
                                    onVNeuChange: _ctx.rowCountChange
                                  }, null, 8, ["total", "page-number", "onVNeuChange"])
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true)
                ]))
              : _createCommentVNode("", true),
            (_ctx.isManageContractVisible)
              ? (_openBlock(), _createElementBlock("div", _hoisted_75, [
                  _hoisted_76,
                  _createElementVNode("div", _hoisted_77, [
                    _createElementVNode("a", {
                      id: "manage-contract-labor-lnk",
                      class: "mr-1",
                      href: _ctx.contractLaborLink,
                      target: "_blank"
                    }, " Manage Contract Labor", 8, _hoisted_78)
                  ])
                ]))
              : _createCommentVNode("", true)
          ])
        ])
      ])
    ]),
    (_ctx.isToasterVisible)
      ? (_openBlock(), _createElementBlock("div", _hoisted_79, [
          _createVNode(_component_ToasterPopup, {
            onCloseModal: _ctx.closeToasterPopup,
            msgValue: _ctx.msgValue,
            classFlag: _ctx.classFlag
          }, null, 8, ["onCloseModal", "msgValue", "classFlag"])
        ]))
      : _createCommentVNode("", true)
  ], 64))
}